import { Injectable } from "@angular/core";
import { IncompleteAppInquiry } from "../../layout/applications/application-models/IncompleteAppInquiry";
import { IncompleteApp } from "../../layout/applications/application-models/IncompleteApp";
import { IncompleteApps } from "../../layout/applications/application-models/IncompleteApps";
import { HttpClient, } from "@angular/common/http";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { CompleteAppRequest } from "../../layout/applications/application-models/CompleteAppRequest";
import { MercuryApplicationNotesInq, MercuryNotesList } from "app/shared/models/MercuryApplicationNotes";
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class EvoToastr {
    public readonly defaultToastOptions = { timeOut: 4000, progressBar: true, tapToDismiss: false, closeButton: true, positionClass: 'toast-top-center' }
    constructor(private toastr: ToastrService) {
        //Construct stuff
    }

    /**
     * Toasts a failure message with default configuration unless provided 
     * @param title title of the toastr message
     * @param message body of the toastr message
     * @param options ngx-toastr optional config 
     */
    public toastFailure(title: string, message: string, options?: any) {
        if (!options) { options = this.defaultToastOptions; }
        this.toastr.error(message, title, options);
    }

    /**
     * Toasts a success message with default configuration unless provided 
     * @param title title of the toastr message
     * @param message body of the toastr message
     * @param options ngx-toastr optional config
     */
    public toastSuccess(title: string, message: string, options?: any) {
        if (!options) { options = this.defaultToastOptions; }
        this.toastr.success(message, title, options);
    }
}